import { IAppState } from '../types';

export const selectExperiments = (state: IAppState) => state.experiments;
